import { Empty, Skeleton } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { AiOutlineFileText, AiOutlineLink } from "react-icons/ai";
import { serverUrl } from "../../../../../nestserver";
import ModuleDetails from "./ModuleDetails";

function SubjectModule({ subjectDetails }) {
  // fetch Modules
  async function getModules() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/modules/",
      params: {
        subject: subjectDetails?._id,
        published: true,
      },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }

  const modules = useQuery(["modules", subjectDetails?._id], getModules);

  // set selected module
  const [moduleDetails, setModuleDetails] = useState(null);

  return (
    <div className="pt-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className="bg-white p-8 drop-shadow-md w-full"
      >
        {moduleDetails ? (
          <ModuleDetails
            subject={subjectDetails}
            data={moduleDetails}
            goBack={() => setModuleDetails(null)}
          />
        ) : modules.isLoading ? (
          <Skeleton active />
        ) : modules?.data?.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {modules.data.map((module) => (
              <div
                key={module._id}
                onClick={() => setModuleDetails(module)}
                className="cursor-pointer bg-white rounded-2xl p-5 flex flex-col justify-between"
                style={{
                  border: "1px solid #eef1f4",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  minHeight: 190,
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 24px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 8px rgba(0,0,0,0.06)";
                }}
              >
                <div>
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center mb-3"
                    style={{ background: "#e0f2fe", color: "#00627B" }}
                  >
                    <AiOutlineFileText size={20} />
                  </div>
                  <h1
                    className="font-semibold text-base line-clamp-2"
                    style={{ color: "#00627B" }}
                  >
                    {module?.title}
                  </h1>
                  <p
                    style={{ color: "#9CA3AF" }}
                    className="font-normal text-sm text-left pt-2 line-clamp-3"
                  >
                    {module?.overview || "No overview provided"}
                  </p>
                </div>
                {!!module?.urls?.length && (
                  <div
                    className="flex items-center gap-1 text-xs pt-4"
                    style={{ color: "#00627B" }}
                  >
                    <AiOutlineLink size={14} />
                    {module.urls.length} resource
                    {module.urls.length > 1 ? "s" : ""}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <Empty description="No modules published yet" />
        )}
      </div>
    </div>
  );
}

export default SubjectModule;
